<template>
  <div
    ref="ConversationBody"
    class="z2-conversation-body scrollbar"
    style="position: relative"
    @click="onClickBox"
    @scroll="onCheckScroll">
    <div
      v-for="message in messageList"
      :key="message.type === 'timeline' ? 'timeline' + message.id.msgId : message.id.msgId"
      class="z2-message-container">
      <div
        v-if="message.type === 'timeline'"
        class="w-100 text-center my-2">
        <span
          class="px-2 py-1 rounded-pill font-12 text-white"
          style="background-color: rgba(55, 60, 65, 0.3)">
          {{ timestampToDatetime(message.ts) }}
        </span>
      </div>
      <MessageItemV2
        v-else
        :id="message.id.msgId.toString()"
        :ref="'message' + message.id.msgId"
        :is-group="conversation.group"
        :message="message"
        :messageList="messageList"
        :accountId="conversation.accountId"
        :conversation="conversation"
        :send-by-list="sendByList"
        :replace-url="replaceUrl"
        :members="members"
        :pinMessages="pinMessages"
        @editTopic="$emit('editTopic', message)"
        @showReactionListDetail="showReactionListDetail"
        @showProfile="openProfile"
        @showRepliedMessage="$emit('showRepliedMessage', message)"
        @showMessageSharePopup="showMessageSharePopup"
        @copy="copy"
        @downloadImage="downloadImage"
        @undoMessage="undoMessage"
        @deleteMessage="deleteMessage"
        @pinMessage="pinMessage"
        @unPinMessage="(isPinMsg) => $emit('unPinMessage', isPinMsg)"
        @clickMessageReplied="onClickMessageReplied(message)" />
    </div>

    <el-button
      v-if="showScrollButton && !newMess"
      @click="scrollToBottom"
      style="position: fixed"
      :style="{ right: !isExpand ? '2rem' : '332px', bottom: buttonScrollBottom }"
      class="btn-scroll"
      :class="buttonAnimation"
      circle
      size="mini">
      <IconV2
        name="v2-arrow2_drop_down"
        size="1.5rem" />
    </el-button>

    <div
      v-if="!showScrollButton && canLoadMoreAfter"
      style="position: fixed; width: 300px"
      :style="{ right: !isExpand ? '1rem' : '316px', bottom: buttonScrollBottom }">
      <div
        @click="scrollToLoadmoreAfter"
        class="position-absolute pointer fw-semibold rounded-2 btn-jump">
        <span>
          <i
            class="el-icon-d-arrow-left ms-1 me-1 align-self-end"
            style="rotate: -90deg"></i>
        </span>
        Cuộn xuống tin nhắn cuối
      </div>
    </div>

    <div
      v-if="showScrollButton && newMess"
      style="position: fixed; width: 200px"
      :style="{ right: !isExpand ? '1rem' : '316px', bottom: buttonScrollBottom }">
      <div
        @click="scrollToBottom"
        class="position-absolute pointer fw-semibold rounded-2 btn-jump">
        <span>
          <i
            class="el-icon-d-arrow-left ms-1 me-1 align-self-end"
            style="rotate: -90deg"></i>
        </span>
        Có tin nhắn mới
      </div>
    </div>

    <!-- <el-button
      v-if="showScrollButton"
      @click="scrollToBottom"
      style="position: fixed; bottom: 10rem; right: 2rem"
      class="btn-scroll"
      :class="buttonAnimation"
      size="mini">
      <div
        class="d-flex align-items-center"
        style="color: #3484f0">
        <span class="mb-1 me-2">Có tin nhắn mới</span>
        <div>
          <IconV2
            name="v2-arrow2_drop_down"
            color="#3484f0" />
          <IconV2
            style="margin-top: -0.625rem"
            color="#3484f0"
            name="v2-arrow2_drop_down" />
        </div>
      </div>
    </el-button> -->

    <scroll-loader
      v-if="readyLoadMore && canLoadMore"
      :loader-method="loadMoreMessage"
      :loader-disable="noMore"
      class="w-100"></scroll-loader>
    <el-dialog
      v-if="app.isShowTodoDetail"
      width="60vw"
      title="Chi tiết công việc"
      :visible.sync="app.isShowTodoDetail"
      :destroy-on-close="true">
      <TodoDetail
        :members="members"
        :selected-account="{ accountId: conversation.accountId }"
        :todo-item="app.todoItem" />
    </el-dialog>
    <!-- <el-dialog
      top="2vh"
      v-if="showMessageShare"
      title="Chia sẻ"
      width="520px"
      :visible.sync="showMessageShare"
      :close-on-click-modal="false"
      :destroy-on-close="true">
      <SharePopup
        :message="messageShare"
        :selectConversation="conversation"
        @closeSharePopup="showMessageShare = false"
        :message-list="messageList" />
    </el-dialog> -->

    <DialogShareMessage
      v-if="showMessageShare"
      :showMessageShare="showMessageShare"
      :message="messageShare"
      :conversation="conversation"
      :accountId="conversation.accountId"
      :message-list="messageList"
      @closeSharePopup="showMessageShare = false" />

    <el-dialog
      top="2vh"
      v-if="showMessageShareV2"
      title="Chia sẻ"
      width="520px"
      :accountId="conversation.accountId"
      :visible.sync="showMessageShareV2"
      :close-on-click-modal="false"
      :destroy-on-close="true">
      <SharePopupV2
        :accountId="conversation.accountId"
        :message="messageShareV2"
        :selectConversation="conversation"
        @closeSharePopup="showMessageShareV2 = false"
        :message-list="messageList" />
    </el-dialog>

    <el-dialog
      v-if="showProfile && conversationMember.accountId"
      width="300px"
      :visible.sync="showProfile"
      title="Thông tin tài khoản"
      class="dialogProfileV2">
      <div
        slot="title"
        class="font-16 fw-500">
        Thông tin tài khoản
      </div>
      <ProfileInfoPopupV2
        :data="profileMember"
        :conversation="conversationMember"
        @closeProfile="showProfile = false" />
    </el-dialog>
    <el-dialog
      v-if="showReactionDetail"
      top="30vh"
      class="dialogReactionDetail"
      :visible.sync="showReactionDetail"
      title="Biểu cảm"
      width="450px"
      :close-on-click-modal="false"
      :destroy-on-close="true">
      <MessageReactionList
        :conversation="conversation"
        :reactionList="reactionList"
        :members="members" />
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import MessageItemV2 from "./MessageItemV2";
import TodoDetail from "./todo/TodoDetail";
import SharePopup from "./message/SharePopup";
import ProfileInfoPopupV2 from "./ProfileInfoPopupV2.vue";
import SharePopupV2 from "./message/SharePopupV2";
import MessageReactionList from "./message/MessageReactionList.vue";
import DialogShareMessage from "./message/DialogShareMessage.vue";
import moment from "moment";
import { downloadImagesAsZip } from "../lib/file";

export default {
  props: [
    "isExpand",
    "messageList",
    "conversation",
    "members",
    "readyLoadMore",
    "canLoadMore",
    "pinMessages",
    "profile",
    "searchKeyMessage",
    "canLoadMoreAfter",
  ],
  components: {
    MessageItemV2,
    TodoDetail,
    SharePopup,
    ProfileInfoPopupV2,
    SharePopupV2,
    MessageReactionList,
    DialogShareMessage,
  },
  data() {
    return {
      messageParsedList: [],
      noMore: false,
      messageShare: {},
      showMessageShare: false,
      messageShareV2: {},
      showMessageShareV2: false,
      data: {},
      showScrollButton: false,
      buttonAnimation: "",
      newMessage: false,

      sendByList: [],
      replaceUrl: [],

      showProfile: false,
      conversationMember: {},
      profileMember: {},
      isExpandTag: false,
      showLink: false,
      showReplied: false,
      reactionList: [],
      showReactionDetail: false,
    };
  },
  watch: {
    conversation() {
      // console.log("log conver");
    },
  },
  computed: {
    buttonScrollBottom() {
      if (this.isExpandTag && this.showReplied) {
        return "385px";
      }
      if (this.isExpandTag && this.showLink) {
        return "425px";
      }
      if (this.showReplied) return "200px";
      if (this.showLink) return "235px";
      if (this.isExpandTag) return "335px";
      return "9rem";
    },
  },
  methods: {
    timestampToDatetime(ts) {
      return moment(Number(ts)).format("DD/MM/YYYY HH:mm");
    },
    loadMoreMessage() {
      this.$emit("loadMore");
    },
    showReactionListDetail(reactionList) {
      this.reactionList = reactionList;
      this.showReactionDetail = true;
    },
    copy(message) {
      let code;
      try {
        code = JSON.parse(message.content).title || message.content;
      } catch (e) {
        code = message.content;
      }
      const el = document.createElement("textarea");
      el.value = code;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
    showMessageSharePopup(message) {
      this.messageShare = message;
      this.showMessageShare = true;
    },

    pinMessage(message) {
      if (this.profile.isBlocked === 1) {
        return this.alert("error", "Yêu cầu thực hiện không thành công vì bạn hoặc người này đã chặn nhau");
      }
      if (this.profile.isFr === 0) {
        return this.alert("error", "Yêu cầu thực hiện không thành công vì 2 bạn chưa kết bạn trên zalo");
      }
      this.$emit("pinMessage", message);
    },
    unPinMessage(message) {},
    deleteMessage(message) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        group: this.conversation.group,
        cliMsgId: message.cliMsgId,
        globalMsgId: message.id.msgId,
        ownerId: this.conversation.toId,
        destId: this.conversation.toId,
      };
      this.$http.post("/api/message/delete", request);
    },
    undoMessage(message) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        group: this.conversation.group,
        msgId: message.id.msgId,
        cliMsgIdUndo: message.cliMsgId,
      };
      if (new Date().getTime() - Number(message.ts) > 24 * 60 * 60 * 1000) return this.alert("error", "Bạn chỉ có thể thu hồi tin nhắn trong vòng 24h");
      this.$http.post("/api/message/undo", request);
    },
    async downloadImage(message) {
      let groupLayoutId = JSON.parse(JSON.parse(message.content).params).group_layout_id;
      if (!groupLayoutId || groupLayoutId == -1) {
        let url = JSON.parse(message.content).href;
        this.download(url);
        this.alert("success", "Tải ảnh về thành công!");
        return;
      }
      let photos = [];
      let filter = this.messageList.filter((p) => p.msgType == "chat.photo");
      filter.forEach((item) => {
        let params = JSON.parse(JSON.parse(item.content).params);
        if (params.is_group_layout) {
          if (params.group_layout_id == groupLayoutId) {
            const existPhoto = photos.find((p) => p.id == params.id_in_group);
            if (!existPhoto) {
              photos.push({ id: params.id_in_group, url: this.findUrlHDIfExistV2(item.content) });
            }
          }
        }
      });
      // photos.forEach((item) => {
      //   this.download(item.url);
      // });
      downloadImagesAsZip(photos.map((i) => i.url));
      if (photos.length > 0) {
        this.alert("success", "Tải ảnh về thành công!");
        return;
      }
      this.alert("error", "Tải ảnh về thất bại!");
    },
    download(url) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const objectUrl = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = objectUrl;
          link.download = url;
          document.body.appendChild(link);
          link.click();

          URL.revokeObjectURL(objectUrl);
        });
    },

    onCheckScroll(e, newMess) {
      const container = this.$refs.ConversationBody;
      this.showScrollButton = container.scrollTop < -10;
      if (this.showScrollButton) {
        this.newMess = newMess ? true : false;
      }
      this.buttonAnimation = this.showScrollButton ? "fade-in" : "fade-out";
    },
    scrollToBottom() {
      const container = this.$refs.ConversationBody;
      container.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.newMess = false;
    },
    scrollToLoadmoreAfter() {
      this.noMore = true;
      this.$emit("loadLastMessage");
    },
    scrollToHighlight() {
      const messageHighlight = this.messageList.find((m) => m.isHighlightMessage);
      if (messageHighlight) {
        const message10Element = document.getElementById(messageHighlight.id.msgId.toString());
        message10Element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
    scrollToMessage(msgId) {
      const message10Element = document.getElementById(msgId);
      message10Element.scrollIntoView({ behavior: "smooth", block: "center" });
    },

    async openProfile(message) {
      try {
        const memberId = message.id.uidFrom != "0" ? message.id.uidFrom : this.conversation.accountId;
        const mem = this.members.find((m) => m.id == memberId) ? this.members.find((m) => m.id == memberId) : null;
        if (message.id.uidFrom == "0") return;
        this.showProfile = true;

        const respConv = await this.$http.post("/api/conversation/all", {
          accountId: this.conversation.accountId,
          searchKey: "",
          selectedTags: [],
          pageSize: 1,
          page: 1,
          type: "personal",
          toId: mem.id,
        });
        if (respConv.data && respConv.data.content.length) {
          this.conversationMember = respConv.data.content[0];
        } else {
          this.conversationMember = {
            accountId: this.conversation.accountId,
            toId: mem.id,
          };
        }
        const resp = await this.$http.get("/api/message/getProfileInfo", {
          params: {
            accountId: this.conversationMember.accountId,
            profileId: this.conversationMember.toId,
          },
        });
        this.profileMember = resp.data.data.changed_profiles[this.conversationMember.toId];
        this.profileMember.accountId = this.conversationMember.accountId;
      } catch (err) {
        console.log("🚀 ~ openProfile ~ err:", err);
      }
    },
    onClickBox() {
      this.$emit("onClickBox");
    },
    onClickMessageReplied(message) {
      const quoteMsg = JSON.parse(message.quoteMsg);
      // this.scrollToMessage(quoteMsg)
      this.$emit("onClickMessageReplied", quoteMsg);
    },
  },
  mounted() {
    this.$bus.$on("forwardMessage", (message) => {
      this.messageShare = message;
      this.showMessageShare = true;
    });
    this.$bus.$on("forwardMessageMulti", (data) => {
      this.messageShare = data;
      this.showMessageShare = true;
    });

    this.$bus.$on("onExpandTag", (isExpandTag) => {
      this.isExpandTag = isExpandTag;
    });

    this.$bus.$on("onShowLink", (showLink) => {
      this.showLink = showLink;
    });

    this.$bus.$on("onShowReplied", (showReplied) => {
      this.showReplied = showReplied;
    });
  },
  beforeDestroy() {
    this.$bus.$off("forwardMessage");
    this.$bus.$off("forwardMessageMulti");
    this.$bus.$off("onExpandTag");
    this.$bus.$off("onShowLink");
    this.$bus.$off("onShowReplied");
    this.sendByList = [];
    this.replaceUrl = [];
  },
};
</script>

<style lang="scss">
.dialogReactionDetail {
  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>